export const YJS_DEFAULT_LOCAL_ORIGIN = Symbol('slate-collab-yjs:default-local-origin')
